module.exports = __webpack_public_path__ + "img/ring_y_c_null_null@2x.763bab2a.png";